
import { combineReducers } from "redux";

import CenterConfigurationReducer from "./CenterConfigurationReducer";
import UserConfigurationReducer from "./UserConfigurationReducer";
import AddressManagementReducer from "./AddressManagementReducer";
import FeaturedProductReducer from "./FeaturedProductReducer";
import SubcategoriesReducer from "./SubcategoriesReducer";
import NotificationReducer from "./NotificationReducer";
import CategoriesReducer from "./CategoriesReducer";
import ProductReducer from "./ProductReducer";
import OpenpayReducer from "./OpenpayReducer";
import FacultyReducer from "./FacultyReducer";
import CenterReducer from "./CenterReducer";
import BannerReducer from "./BannerReducer";
import AuthReducer from "./authReducer";
import UserReducer from "./UserReducer";
import ApiReducer from "./ApiReducer";
import RolReducer from "./RolReducer";
import DenyReducer from "./DenyReducer";

export default combineReducers({
	center_configuration_reducer: CenterConfigurationReducer,
	user_configuration_reducer:   UserConfigurationReducer,
	address_management_reducer:   AddressManagementReducer,
	featured_product_reducer:     FeaturedProductReducer,
	notification_reducer:         NotificationReducer,
	subcategory_reducer:          SubcategoriesReducer,
	category_reducer:             CategoriesReducer,
	product_reducer:              ProductReducer,
	openpay_reducer:              OpenpayReducer,
	faculty_reducer:              FacultyReducer,
	center_reducer:               CenterReducer,
	banner_reducer:               BannerReducer,
	user_reducer:                 UserReducer,
	deny_reducer:                 DenyReducer,
	api_reducer:                  ApiReducer,
	rol_reducer:                  RolReducer,
	auth:                         AuthReducer,
});
